export default {
  icon: '#818D94',
  primary: '#F5CA00',
  bg: '#F4F7FD'
}